import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { LoginPage } from "@/pages"

const loginSearchSchema = z.object({
  return: z.string().optional(),
})

export const Route = createFileRoute("/_unauthenticated/login")({
  component: LoginPage,
  validateSearch: loginSearchSchema,
})
